import { type HTMLAttributes, forwardRef } from 'react'
import { cn } from '#app/utils/tailwind-merge.ts'

/**
 * Eyebrow pill that labels a section — a hairline-bordered capsule with a
 * small accent dot. Sits above the section heading.
 */
const Pill = forwardRef<
	HTMLSpanElement,
	HTMLAttributes<HTMLSpanElement> & { children: React.ReactNode }
>(({ className, children, ...props }, ref) => (
	<span
		ref={ref}
		className={cn(
			'inline-flex items-center gap-2 rounded-full border border-muted-200 bg-background py-1 pl-2 pr-3 text-xs font-medium text-muted-700',
			className,
		)}
		{...props}
	>
		<span
			aria-hidden
			className="size-1.5 shrink-0 rounded-full bg-accent-dot"
		/>
		{children}
	</span>
))
Pill.displayName = 'Pill'

export { Pill }
